import apiService from './api-service';

const HOLIDAYS_BASE_API = process.env.REACT_APP_API_URI + '/holidays';

export const apiHolidaysService = {
    uploadHolidays,
    getHolidays,
    getHolidaysActive
};

async function uploadHolidays(data: any) {
    const response = await apiService().post(`${HOLIDAYS_BASE_API}/upload`, data);
    return response.data;
}

async function getHolidays(queryParams: any) {
    const response = await apiService().get(`${HOLIDAYS_BASE_API}/list`, { params: queryParams });
    return response.data;
}

async function getHolidaysActive() {
    const response = await apiService().get(`${HOLIDAYS_BASE_API}/active`);
    return response.data;
}